module.exports = __webpack_public_path__ + "static/media/100.38c1fb18.png";